const DataTableEvents = {
    onOrderingChanged: 'on-ordering-changed',
    onOrderingRemoved: 'on-ordering-removed',
};

export default DataTableEvents;